var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDateBlMd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "date_bl_md",
    transform: "translate(-974 -269)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11034",
    "data-name": "Rectangle 11034",
    width: 36,
    height: 36,
    rx: 12,
    transform: "translate(974 269)",
    fill: "#0078d7",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "description_black_24dp",
    transform: "translate(980 275)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46202",
    "data-name": "Path 46202",
    d: "M0,0H24V24H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46203",
    "data-name": "Path 46203",
    d: "M14.59,2.59A2.006,2.006,0,0,0,13.17,2H6A2.006,2.006,0,0,0,4,4V20a2,2,0,0,0,1.99,2H18a2.006,2.006,0,0,0,2-2V8.83a1.966,1.966,0,0,0-.59-1.41L14.59,2.59ZM15,18H9a1,1,0,0,1,0-2h6a1,1,0,0,1,0,2Zm0-4H9a1,1,0,0,1,0-2h6a1,1,0,0,1,0,2ZM13,8V3.5L18.5,9H14A1,1,0,0,1,13,8Z",
    fill: "#0078d7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateBlMd);
export default __webpack_public_path__ + "static/media/date_bl_md.5c525c769931dcfe1ab5244d483393ca.svg";
export { ForwardRef as ReactComponent };